
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ItemChip from "@/components/common/ItemChip.vue";
  import { NO_INFORMATION } from "@/data/placeholders";
  import ItemChipsData from "@/entities/ItemChipsData";

  @Component({
    components: {
      ItemChip,
    },
  })
  export default class CardSingleChip extends Vue {
    @Prop({ type: String, default: "text-label" }) readonly noContentClasses!: string;
    @Prop({ type: Object, default: undefined }) readonly item?: ItemChipsData;
    @Prop({ type: Boolean, default: false }) readonly withAvatar!: boolean;

    get noContent(): boolean {
      return !this.item;
    }

    noContentPlaceholder = NO_INFORMATION;
  }
